import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "conversation-actions__buttons"
}

import { showError } from '@nextcloud/dialogs'
import { getLanguage, t } from '@nextcloud/l10n'
import { spawnDialog } from '@nextcloud/vue/functions/dialog'
import { computed } from 'vue'
import { isNavigationFailure, NavigationFailureType } from 'vue-router'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import NcButton from '@nextcloud/vue/components/NcButton'
import IconCheckUnderline from 'vue-material-design-icons/CheckUnderline.vue'
import IconTrashCanOutline from 'vue-material-design-icons/TrashCanOutline.vue'
import ConfirmDialog from '../../components/UIShared/ConfirmDialog.vue'
import { CONVERSATION } from '../../constants.ts'
import { getTalkConfig, hasTalkFeature } from '../../services/CapabilitiesManager.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationActionsShortcut',
  props: {
    token: {},
    objectType: {},
    isHighlighted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const supportsArchive = hasTalkFeature('local', 'archived-conversations-v2')
const retentionEventPeriod = computed(() => getTalkConfig(props.token, 'conversations', 'retention-event'))
const retentionPhonePeriod = computed(() => getTalkConfig(props.token, 'conversations', 'retention-phone'))
const retentionInstantMeetingPeriod = computed(() => getTalkConfig(props.token, 'conversations', 'retention-instant-meetings'))

const store = useStore()
const router = useRouter()
const route = useRoute()

const isModerator = computed(() => store.getters.isModerator)

const expirationDuration = computed(() => {
	if (props.objectType === CONVERSATION.OBJECT_TYPE.EVENT) {
		return retentionEventPeriod.value
	} else if (props.objectType === CONVERSATION.OBJECT_TYPE.PHONE_TEMPORARY) {
		return retentionPhonePeriod.value
	} else if (props.objectType === CONVERSATION.OBJECT_TYPE.INSTANT_MEETING) {
		return retentionInstantMeetingPeriod.value
	}
	return 0
})

const isShown = computed(() => isModerator.value || expirationDuration.value !== 0)

const descriptionLabel = computed(() => {
	if (expirationDuration.value === 0) {
		return t('spreed', 'Would you like to delete this conversation?')
	}
	const expirationDurationFormatted = new Intl.RelativeTimeFormat(getLanguage(), { numeric: 'always' }).format(expirationDuration.value!, 'days')
	return t('spreed', 'This conversation will be automatically deleted for everyone {expirationDurationFormatted} of no activity.', { expirationDurationFormatted })
})

/**
 * Delete conversation
 */
async function deleteEventConversation() {
	try {
		if (route?.params?.token === props.token) {
			await router.push({ name: 'root' })
				.catch((failure) => !isNavigationFailure(failure, NavigationFailureType.duplicated) && Promise.reject(failure))
		}
		await store.dispatch('deleteConversationFromServer', { token: props.token })
	} catch (error) {
		console.error(`Error while deleting conversation ${error}`)
		showError(t('spreed', 'Error while deleting conversation'))
	}
}

/**
 * Unbind conversation from object
 */
async function resetObjectConversation() {
	await store.dispatch('unbindConversationFromObject', { token: props.token })
}

/**
 * Show confirmation dialog
 */
async function showConfirmationDialog() {
	spawnDialog(ConfirmDialog, {
		name: t('spreed', 'Delete conversation'),
		message: t('spreed', 'Are you sure you want to delete this conversation?'),
		buttons: [
			{
				label: t('spreed', 'No'),
				variant: 'tertiary',
			},
			{
				label: t('spreed', 'Yes'),
				variant: 'error',
				callback: () => {
					deleteEventConversation()
				},
			},
		],
	})
}

return (_ctx: any,_cache: any) => {
  return (isShown.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["conversation-actions", { 'conversation-actions--highlighted': props.isHighlighted }])
      }, [
        _createElementVNode("p", null, _toDisplayString(descriptionLabel.value), 1),
        (isModerator.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(NcButton), {
                variant: "error",
                onClick: showConfirmationDialog
              }, {
                icon: _withCtx(() => [
                  _createVNode(IconTrashCanOutline)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_unref(t)('spreed', 'Delete now')), 1)
                ]),
                _: 1
              }),
              (_unref(supportsArchive))
                ? (_openBlock(), _createBlock(_unref(NcButton), {
                    key: 0,
                    variant: "secondary",
                    onClick: resetObjectConversation
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(IconCheckUnderline)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_unref(t)('spreed', 'Keep')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})